import React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import "../../../../styles/ExpressionBuilder.css";

/**
 * Number input component for expression rule values
 * @param {number} value - Current numeric value
 * @param {Function} onChange - Change handler function
 * @param {Object} rest - Additional props to pass to NumericTextBox
 * @returns {JSX.Element} Number input component
 * @author Abhishek Dhillon
 * @parent ValueInput
 */
const NumberInput = ({ value, onChange, ...rest }) => {
  return (
    <NumericTextBox
      {...rest}
      value={parseFloat(value) || 0}
      onChange={onChange}
      format='n0'
      id='value-input-number'
      className='expression-builder-w-100'
      placeholder='Enter number'
    />
  );
};

export default NumberInput;
